import { cn } from "@/lib/utils";
import { RadioGroup as RadioGroupPrimitive } from "radix-ui";
import { ComponentProps } from "react";
import { tv, type VariantProps } from "tailwind-variants";

const radioVariants = tv({
  base: "data-[invalid=true]:text-destructive gap-2 group/field flex items-start justift-start",
  variants: {
    orientation: {
      vertical: "flex-col *:w-full",
      horizontal: "flex-row items-center",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

function RadioGroup({
  className,
  orientation = "horizontal",
  ...props
}: ComponentProps<typeof RadioGroupPrimitive.Root> &
  VariantProps<typeof radioVariants>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn(radioVariants({ orientation }), className)}
      {...props}
    />
  );
}

function RadioItem({
  className,
  ...props
}: ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "peer aria-invalid:border-destructive flex size-4 shrink-0 items-center justify-center rounded-full border border-black p-0.5 transition-colors outline-none",
        "aria-invalid:border-destructive group-has-disabled/field:opacity-50 disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:ring",
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="flex h-full w-full rounded-full bg-black"
      />
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioItem };
